




import { Component, Prop, Vue } from 'vue-property-decorator';

/**
 * Comment helper so you can have nested comment
 * p.s. I comment out old stuff in case I forget details about past work
 */
@Component({})
export default class Comment extends Vue {}
